module.exports = __webpack_public_path__ + "images/assets/53867e578a2be2c38865446be4304377.svg";